class NewsletterPanel extends Panel {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.inactivityTimeLimit = this.dataset.delay || 12000;
    this.resetEvents = this.dataset.reset.split(',');
    const submitted = this.checkForSubmitted();
    const suppressed = this.checkForSuppressed();
    if (submitted) {
      document.getElementById('panel-container').append(this);
      this.cleanupUrl();
      this.show();
    } else if (!suppressed) {
      document.getElementById('panel-container').append(this);
      this.boundResetInactivityTimer = this.resetInactivityTimer.bind(this);
      this.setupTimer();
    } else {
      this.parentNode.removeChild(this);
    }
  }

  checkForSubmitted() {
    return this.form.dataset?.success === 'true' || window.location.hash === '#NewsletterPopup';
  }

  checkForSuppressed() {
    return this.getCookie('newsletter_suppressed') === '1';
  }

  cleanupUrl() {
    let url = window.location.href;
    url = url.replace('#NewsletterPopup', '');
    url = url.replace('customer_posted=true', '');
    window.history.replaceState(null, '', url);
  }

  setupTimer() {
    this.resetEvents.forEach((event) => {
      document.addEventListener(event, this.boundResetInactivityTimer);
    });
    this.resetInactivityTimer();
  }

  cleanupTimer() {
    this.resetEvents.forEach((event) => {
      document.removeEventListener(event, this.boundResetInactivityTimer);
    });
  }

  resetInactivityTimer() {
    clearTimeout(this.inactivityTimer);
    this.inactivityTimer = setTimeout(this.show.bind(this), this.inactivityTimeLimit);
  }

  show() {
    if (panelManager.state === 'idle') {
      panelManager.dispatch('OPEN_NEWSLETTER');
      this.cleanupTimer();
    } else {
      this.resetInactivityTimer();
    }
  }

  close() {
    this.setCookie('newsletter_suppressed', '1', 365);
    this.parentNode.removeChild(this);
  }

  getCookie(name) {
    const cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      const cookiePair = cookieArray[i].split('=');
      if (name === cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    //super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    requestAnimationFrame(() => {
      if (previousState === 'idle') {
        actions.openRightBottomNav().then(() => {
          window.trapFocus(this, this.querySelector('#newsletter-popup-email'));
        });
      }
    });
  }
}
customElements.define('newsletter-panel', NewsletterPanel);
